module.exports = ".ReceiptCredit .row1 .col-md-2, .ReceiptCredit .row1 .col-md-4{\r\n    padding:0px;\r\n }\r\n "


//////////////////
// WEBPACK FOOTER
// ./src/app/chitfund/miscellaneous-receipt/miscellaneous-receipt.component.css
// module id = ./src/app/chitfund/miscellaneous-receipt/miscellaneous-receipt.component.css
// module chunks = main